export default function($) {
  $(document).ready(function () {
    $('.js-toggle-trigger').click(function (event) {
      event.preventDefault()

      let isCollapsed = $(this).data('is-collapsed')
      let contentId = $(this).data('content-id')
      let contentNode = $('#'+contentId)

      if (contentNode.length <= 0 ) {
        return;
      }

      if (isCollapsed) {
        contentNode.addClass('hidden')
        $(this).find('.js-toggle-hidde').addClass('!hidden')
        $(this).find('.js-toggle-show').removeClass('!hidden')
        $(this).data('is-collapsed', false)
      } else {
        contentNode.removeClass('hidden')
        $(this).find('.js-toggle-hidde').removeClass('!hidden')
        $(this).find('.js-toggle-show').addClass('!hidden')
        $(this).data('is-collapsed', true)
      }
    })
  })
}
